<div class="sortmodal">

    
    <div class="card col-12 col-sm-4 offset-sm-4">
        <div class="card-header">
            Finance Calculator
        </div>
        <div class="card-body ">
            
            <div *ngFor="let s of sorts" class="row">
                <p (click)="sortclick(s.value)" >{{s.Name}}</p>
            </div>
            
        </div>
    </div>
</div>